/**
 * 腾讯im聊天模块
 * Bai.Zhiming
 * 2019-7-8
 */
angular.module('IMModule', [
    'chatWindowModule',
    'imServiceModule',
    'convertMsgtoHtmlModule',
    'chatTipBarModule',
    'IMDirectiveModule'
]);
